import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Daniel Williams', 
        title: 'Globetrotter',
        content: 'The Private Island Retreat was the ultimate luxury escape. Every detail, from the secluded beaches to the personalized services, made me feel like royalty. It’s an experience that redefined relaxation for me.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Olivia Thompson', 
        title: 'Adventure Enthusiast',
        content: "The Desert Safari Adventure was thrilling beyond words. From the exhilarating dune bashing to the serene desert night under the stars, it was an unforgettable journey that combined culture and excitement perfectly."
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Ethan Carter', 
        title: 'History Buff',
        content: 'The Historical City Tour was a dream come true. Walking through centuries-old streets with knowledgeable guides made the city’s rich heritage come alive. Every corner had a story to tell.'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Sophia Reynolds', 
        title: 'Beach Lover',
        content: "Staying at the Luxury Beach Resort was absolute bliss. The overwater villa, crystal-clear waters, and impeccable hospitality created a peaceful and luxurious retreat. I didn’t want to leave!"
    },
];

export default testimonials;